import { render } from "./SubmissionFormView.vue?vue&type=template&id=223c034c&scoped=true&ts=true"
import script from "./SubmissionFormView.vue?vue&type=script&lang=ts"
export * from "./SubmissionFormView.vue?vue&type=script&lang=ts"

import "./SubmissionFormView.vue?vue&type=style&index=0&id=223c034c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223c034c"]])

export default __exports__